import React from 'react'
//images
import pepe1 from '../assets/images/pepe1.jpeg'
import pepe2 from '../assets/images/pepe2.jpeg'
import pepe3 from '../assets/images/pepe3.jpeg'
import yoda1 from '../assets/images/yoda1.jpeg'
import yoda2 from '../assets/images/yoda2.jpeg'
import yoda3 from '../assets/images/yoda3.jpeg'
import yoda4 from '../assets/images/yoda4.jpeg'
import TMOTY from '../assets/images/TMOTY.jpeg'
//pdf 
import whitepaper from '../assets/images/whitepaper.pdf'
//type animation
import { TypeAnimation } from 'react-type-animation'
//motion
import { motion } from 'framer-motion'
//variants'
import { fadeIn } from '../variants';

const HeroSection = () => {
    return (
        <div className='font-mooli min-h-screen' id='home'>
            <div className='flex flex-col text-center font-bold justify-center items-center space-y-6 pt-12'>
                <motion.h1
                    variants={fadeIn('up', 0.3)}
                    initial='hidden'
                    whileInView={'show'}
                    viewport={{ once: false, amount: 0.7 }}
                    className='text-5xl md:text-7xl text-[#283618] font-thin'>THE MAN OF THE YEAR</motion.h1>
                <motion.div
                 variants={fadeIn('up',0.6)}
                 initial='hidden'
                 whileInView={'show'}
                 viewport={{once:false,amount:0.7}}
                
                className='  justify-center items-start p-4 flex space-x-4 bg-white/10 rounded-xl backdrop-blur-2xl'>
                    {/* <img src={yoda2} alt='pepe1 ' className='h-72 hidden lg:flex hover:scale-95 transition-transform rounded-2xl shadow-2xl backdrop-blur-2xl ' /> */}
                    <img src={TMOTY} alt='pepe2' className='h-72 hover:scale-95 transition-transform rounded-2xl  shadow-2xl backdrop-blur-2xl ' />
                    {/* <img src={yoda3} alt='pepe3' className='h-72 hidden lg:flex hover:scale-95 transition-transform rounded-2xl shadow-2xl backdrop-blur-2xl' /> */}

                </motion.div>

                <motion.p 
                 variants={fadeIn('up',0.7)}
                 initial='hidden'
                 whileInView={'show'}
                 viewport={{once:false,amount:0.7}}
                className='text-[#344e41] text-lg text-center max-w-6xl'>“ Satoshi Nakamoto is the pseudonymous individual or group of individuals who created Bitcoin, the first cryptocurrency, and authored the Bitcoin whitepaper in 2008. The true identity of Satoshi Nakamoto remains unknown, and it has sparked much speculation and curiosity in the cryptocurrency community and beyond. Satoshi Nakamoto disappeared from public view in 2010, leaving the development of Bitcoin to the community ”</motion.p>
               
            </div>
        </div>
    )
}

export default HeroSection
